<template>
  <pt-points-grant-form ref="form" class="pt-points-grant-form__withData" :bussinessTypes="bussinessTypes" :fromType="fromType" :departmentLoading="departmentLoading"
  @getRewardBusinessType="getRewardBusinessType" @changeBusinessType="changeBusinessType" :businessDepartments="businessDepartments"></pt-points-grant-form>
</template>

<script>
import PtPointsGrantForm from './form'
export default {
  name: 'pt-points-grant-form__withData',
  components: {
    'pt-points-grant-form': PtPointsGrantForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    fromType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      bussinessTypes: [],
      bussinessTypeLoading: false,
      businessDepartments: [],
      departmentLoading: false
    }
  },
  methods: {
    getBusinessDepartment () {
      this.departmentLoading = true
      this.$store.dispatch('getBusinessDepartment').then(res => {
        this.departmentLoading = false
        this.businessDepartments = res
      }).catch(err => {
        this.departmentLoading = false
        this.$message.error(err || '获取业务部列表失败')
      })
    },
    changeBusinessType (val) {
      let flag = false
      this.bussinessTypes.forEach(item => {
        if (item.value === val || item.name === val) {
          flag = true
        }
      })
      if (!flag && val) {
        this.createRewardBusinessType(val)
      }
    },
    // 创建奖励枚举
    createRewardBusinessType (val) {
      let data = {
        name: val,
        value: val
      }
      this.$store.dispatch('createRewardBusinessType', data).then(res => {
        this.getRewardBusinessType()
      }).catch(err => {
        this.$message.error(err || '新建奖励类型失败')
      })
    },
    // 获取奖励类型枚举
    getRewardBusinessType () {
      this.bussinessTypeLoading = true
      this.$store.dispatch('getRewardBusinessType').then(res => {
        this.bussinessTypes = res
        this.bussinessTypeLoading = false
      }).catch(err => {
        this.$message.error(err || '获取奖励类型失败')
        this.bussinessTypeLoading = false
      })
    },
    // 判断是否已选择用户
    isSelectedUser () {
      let importCustomer = false
      let formValue = this.form.formValue
      if (formValue.mallUserCriteria && formValue.mallUserCriteria && formValue.mallUserCriteria.whiteList &&
      formValue.mallUserCriteria.whiteList.length) {
        formValue.mallUserCriteria.whiteList.forEach(item => {
          for (let key in item) {
            if (item[key] || item.bindCps === false) {
              importCustomer = true
            }
          }
        })
      }
      return (formValue.userIds && this.form.formValue.userIds.length) || importCustomer
    },
    submit () {
      this.$nextTick(_ => {
        if (this.isSelectedUser()) {
          this.form.form.validate().then(formValue => {
            this.businessDepartments.forEach(item => {
              if (item.id === this.form.formValue.businessDepartmentId) {
                this.form.formValue.businessDepartmentName = item.name
              }
            })
            this.$emit('submitSuccess', true)
            this.$store.dispatch('createPointsReward', this.form.formValue).then(data => {
              // doing something ...
              this.$message.success('发放奖励成功')
              this.$emit('submitSuccess', false)
              history.go(-1)
            }).catch(errorMessage => {
              this.$emit('submitSuccess', false)
              this.$message.error(errorMessage || '发放奖励失败')
            })
          })
        } else {
          this.$message.error('请选择用户')
        }
      })
    }
  },
  created () {
    this.getBusinessDepartment()
    this.getRewardBusinessType()
  }
}
</script>
